import { getFeedsStats } from '@op/services';
import { percentageFormat, reviewsFormat } from '@op/utils/value';
import { useEffect, useState } from 'react';

export type FeedsStateType =
  | {
      TOTAL_NUM?: string | number;
      POS_RATIO?: string | number;
      NEU_RATIO?: string | number;
      NEG_RATIO?: string | number;
      TOTAL_POS?: string | number;
      TOTAL_NEU?: string | number;
      TOTAL_NEG?: string | number;
      POSITIVE_ENGAGEMENT?: string | number;
      POSITIVE_LIKES?: string | number;
      NEGATIVE_ENGAGEMENT?: string | number;
      NEGATIVE_LIKES?: string | number;
      NEUTRAL_ENGAGEMENT?: string | number;
      NEUTRAL_LIKES?: string | number;
      TOTAL_ENGAGEMENT?: string | number;
    }
  | undefined;

/**
 * 请求state接口数据
 * @param filter        过滤器数据
 * @param needRequest   是否自动请求数据
 * @param backStateData 返回原始的接口数据
 * @param oriFeedsState 原始的默认接口数据
 * @returns
 */
export default function useRequestFeedsState({
  filter,
  needRequest,
  backStateData,
  oriFeedsState,
}: {
  filter: any;
  needRequest?: boolean;
  backStateData?: (data: any) => void;
  oriFeedsState?: any;
}) {
  const [loading, setLoading] = useState(needRequest);
  const [feedsState, setFeedsState] = useState<FeedsStateType>(undefined);
  const [total, setTotal] = useState<number>(0);

  function getFeedsStateValue(feedsStats: any) {
    const {
      total = 0,
      bad_total = 0,
      neutral_total = 0,
      good_total = 0,
      positive_engagement = 0,
      positive_like = 0,
      negative_engagement = 0,
      negative_like = 0,
      neutral_engagement = 0,
      neutral_like = 0,
    } = feedsStats || {};

    let positivePercent = 0;
    let negativePercent = 0;
    let neutralPercent = 0;
    if (total) {
      positivePercent = (good_total / total) * 100;
      negativePercent = (bad_total / total) * 100;
      neutralPercent = (neutral_total / total) * 100;
    }

    return [
      {
        TOTAL_NUM: reviewsFormat(total),
        POS_RATIO: percentageFormat(positivePercent),
        NEU_RATIO: percentageFormat(neutralPercent),
        NEG_RATIO: percentageFormat(negativePercent),
        TOTAL_POS: reviewsFormat(good_total),
        TOTAL_NEU: reviewsFormat(neutral_total),
        TOTAL_NEG: reviewsFormat(bad_total),
        POSITIVE_ENGAGEMENT: reviewsFormat(positive_engagement),
        POSITIVE_LIKES: reviewsFormat(positive_like),
        NEGATIVE_ENGAGEMENT: reviewsFormat(negative_engagement),
        NEGATIVE_LIKES: reviewsFormat(negative_like),
        NEUTRAL_ENGAGEMENT: reviewsFormat(neutral_engagement),
        NEUTRAL_LIKES: reviewsFormat(neutral_like),
        TOTAL_ENGAGEMENT: reviewsFormat(
          positive_engagement + negative_engagement + neutral_engagement,
        ),
      },
      total,
    ];
  }

  function dealwithFeedsState(data: any) {
    const [value, total] = getFeedsStateValue(data);
    setFeedsState(value);
    backStateData?.(data);
    setTotal(total);
    setLoading(false);

    return value;
  }
  async function requestFeedsStateData() {
    setLoading(true);
    let data = oriFeedsState;
    if (!oriFeedsState) {
      const { sort_item, sort_model, ...otherFilter } = filter || {};
      data = await getFeedsStats(otherFilter);
    }
    const value = dealwithFeedsState(data);
    return value;
  }

  useEffect(() => {
    if (filter?.edition_unified_id && needRequest) {
      requestFeedsStateData();
    }
  }, [filter]);

  useEffect(() => {
    if (oriFeedsState) {
      requestFeedsStateData();
    }
  }, [oriFeedsState]);

  return {
    loading,
    feedsState,
    requestFeedsStateData,
    total,
  };
}
